import { cloneDeep } from 'lodash';
import { SET_ANALYSIS_EVENTS, SET_ANALYSIS_EVENTS_SORTING } from './consts';

import { PROJECTS_TAG } from '../../../projects/data/actions';

export const SET_ANALYSIS_ACTIVE_EVENT = 'SET_ANALYSIS_ACTIVE_EVENT';

export const setProjectAnalysisEventsSorting = eventsSorting => {
  return {
    type: SET_ANALYSIS_EVENTS_SORTING,
    eventsSorting
  };
};

export const setProjectAnalysisEvents = events => {
  return {
    type: SET_ANALYSIS_EVENTS,
    events
  };
};

export const setActiveEventId = activeEventId => {
  return {
    type: SET_ANALYSIS_ACTIVE_EVENT,
    activeEventId
  };
};

export const fetchProjectAnalysisEvents = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, 'getProjectEvents', {
      projectId,
      $limit: 100
    });

    dispatch(setProjectAnalysisEvents(results.data));
  };
};

export const eventsSortingUpHandler = () => {
  return (dispatch, getState) => {
    const { activeLayerId } = getState().analysis.single;
    const { activeEventId } = getState().analysis.single;

    if (activeLayerId === null || activeEventId === null) {
      return;
    }

    const layerEventsSorting = cloneDeep(getState().analysis.single.eventsSorting);
    const activeLayerEventsSorting = layerEventsSorting[activeLayerId].slice();
    const activeEventsIndex = activeLayerEventsSorting.indexOf(activeEventId);

    if (activeEventsIndex === 0) {
      return;
    }

    const itemToSwap = activeLayerEventsSorting[activeEventsIndex];
    const toIndex = activeEventsIndex - 1;

    activeLayerEventsSorting[activeEventsIndex] = activeLayerEventsSorting[toIndex];
    activeLayerEventsSorting[toIndex] = itemToSwap;

    dispatch(
      setProjectAnalysisEventsSorting({
        ...layerEventsSorting,
        [activeLayerId]: activeLayerEventsSorting
      })
    );
  };
};

export const eventsSortingDownHandler = () => {
  return (dispatch, getState) => {
    const { activeLayerId } = getState().analysis.single;
    const { activeEventId } = getState().analysis.single;

    if (activeLayerId === null || activeEventId === null) {
      return;
    }

    const layerEventsSorting = cloneDeep(getState().analysis.single.eventsSorting);
    const activeLayerEventsSorting = layerEventsSorting[activeLayerId].slice();
    const activeEventsIndex = activeLayerEventsSorting.indexOf(activeEventId);

    if (activeEventsIndex === activeLayerEventsSorting.length - 1) {
      return;
    }

    const itemToSwap = activeLayerEventsSorting[activeEventsIndex];
    const toIndex = activeEventsIndex + 1;

    activeLayerEventsSorting[activeEventsIndex] = activeLayerEventsSorting[toIndex];
    activeLayerEventsSorting[toIndex] = itemToSwap;

    dispatch(
      setProjectAnalysisEventsSorting({
        ...layerEventsSorting,
        [activeLayerId]: activeLayerEventsSorting
      })
    );
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/eventsActions.js